export var Action;
(function (Action) {
    Action["click"] = "click";
    Action["focus"] = "focus";
    Action["hover"] = "hover";
    Action["contextMenu"] = "contextMenu";
})(Action || (Action = {}));
export var ShowAction;
(function (ShowAction) {
    ShowAction["click"] = "click";
    ShowAction["focus"] = "focus";
    ShowAction["mouseEnter"] = "mouseEnter";
    ShowAction["contextMenu"] = "contextMenu";
})(ShowAction || (ShowAction = {}));
export var HideAction;
(function (HideAction) {
    HideAction["click"] = "click";
    HideAction["blur"] = "blur";
    HideAction["mouseLeave"] = "mouseLeave";
})(HideAction || (HideAction = {}));
